import React, { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useResponsive } from '../../utils/customHooks';
import { SkodaSwiper, SkodaSwiperProps } from '../swiper';
import { PlusCardProps } from './plusCard';

export type PlusCardsProps = SkodaSwiperProps & {
	children: React.ReactElement<PlusCardProps>[];
};

const useStyles = makeStyles({ name: 'PlusCards' })(theme => ({
	root: {
		'&.swiper-container-horizontal': {
			overflow: 'hidden'
		}
	},
	slide: {
		width: 280,
		[theme.breakpoints.up('md')]: {
			width: 'unset'
		}
	},
	plusCard: {
		height: '100%'
	}
}));

export const PlusCards: React.FC<PlusCardsProps> = (props) => {
	const { children, className, ...other } = props;
	const { classes, cx } = useStyles();

	const responsive = useResponsive();

	const slidesPerView = responsive({
		xs: 'auto' as 'auto',
		md: 3
	});

	const spaceBetween = responsive({
		xs: 30,
		lg: 48
	});

	const enrichedChildren = useMemo(() => React.Children
		.map(children, (child: React.ReactElement<PlusCardProps>) =>
			React.cloneElement(child, { ...child.props, className: cx(child.props.className, classes.plusCard) }))
		.filter(child => child.props.title?.length && child.props.icon?.length),
		[children, classes, cx]);

	const navigation = useMemo(() => {
		return slidesPerView === 'auto'
			? enrichedChildren.length > 1
			: slidesPerView < enrichedChildren.length;
	}, [slidesPerView, enrichedChildren]);

	return (
		<SkodaSwiper
			className={cx(classes.root, className)}
			classes={{ slide: classes.slide }}
			slidesPerView={slidesPerView}
			spaceBetween={spaceBetween}
			children={enrichedChildren}
			navigation={navigation}
			{...other} />
	);
};

PlusCards.defaultProps = {
	activeSlideEffects: false,
	scrollbar: false
};
